DatabaseXCommandModalController.$inject= ['DatabaseService', 'StorageService', '$interval'];
export default function DatabaseXCommandModalController(DatabaseService, StorageService, $interval) {
    var ctrl = this;
    var periodic_interval = 5000;
    var periodic;

    ctrl.isSuccess = false;
    ctrl.isProcess = false;
    ctrl.isError = false;

    ctrl.load_file = function() {
        StorageService.get({id: ctrl.file}).$promise.then(function(response) {
            ctrl.content_file = response;
        });
    };

    ctrl.$onChanges = function(changes) {
        if (changes) {
            ctrl.title = changes.resolve.currentValue.params.title;
            ctrl.command = changes.resolve.currentValue.params.command;
            ctrl.database = changes.resolve.currentValue.params.database;
            ctrl.file = changes.resolve.currentValue.params.file;
            if (ctrl.command === 'update') {
                ctrl.load_file();
            }
        }
    };

    ctrl.$onInit = function() {
        if (ctrl.command === 'update') {
            periodic = $interval(ctrl.load_file, periodic_interval);
        }
    };

    ctrl.$onDestroy = function() {
        if (ctrl.command === 'update') {
            console.log('Desctroy periodic');
            $interval.cancel(periodic);
        }
    };

    ctrl.xcommand = function() {
        var qs = {
            id: ctrl.database,
            command: ctrl.command
        };

        if (qs.command === 'update') {
            qs.file = ctrl.file;
        }

        ctrl.isProcess = true;

        DatabaseService.get(qs).$promise.then(function(response) {
            if (response.success) {
                ctrl.response = response;
                ctrl.isSuccess = true;
            } else {
                ctrl.isError = true;
            }
            ctrl.load_file();
            ctrl.isProcess = false;
        }, function(error) {
            console.log(error);
            ctrl.isError = error;
            ctrl.isProcess = false;
        });
    };

    ctrl.$onDestroy = function() {
        console.log('Desctroy periodic')
        $interval.cancel(periodic);
    }

    ctrl.ok = function() {
        ctrl.modalInstance.close(ctrl.content);
    };

    ctrl.cancel = function() {
        ctrl.modalInstance.dismiss("cancel");
    };
}
